import { useEffect } from 'react'

/** Kept identical to the <title> in index.html. */
export const SITE_TITLE = 'Ovrsee | Team performance insight, without surveillance'

/**
 * Sets the document title for the mounted screen and puts back whatever was there when
 * it unmounts. Callers pass the bare screen name; the brand suffix is added here.
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = `${title} | Ovrsee`
    return () => {
      document.title = previous
    }
  }, [title])
}
